'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SiteNavigation;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'site-navigation';

function SiteNavigation(_ref) {
  var links = _ref.links;

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    _react2.default.createElement(
      'div',
      { className: 'header-links' },
      links.map(function (_ref2, key) {
        var label = _ref2.label,
            altTitle = _ref2.altTitle,
            href = _ref2.href;
        return _react2.default.createElement(
          _reactRouter.Link,
          {
            key: key,
            to: href
          },
          _react2.default.createElement(
            'span',
            { className: 'responsive' },
            label
          ),
          _react2.default.createElement(
            'span',
            { className: 'desktop-only' },
            altTitle
          )
        );
      })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SiteNavigation/SiteNavigation.jsx
// module id = 1130
// module chunks = 0